//--------------------------REACT---------------------------------//
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

//--------------------------MATERIAL-UI---------------------------------//
import { Grid, IconButton, LinearProgress } from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";

//--------------------------THIRD-PARTY---------------------------------//
import ls from "local-storage";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { isMobile } from "react-device-detect";

//--------------------------COMPONENTS---------------------------------//
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import RequestCard from "../../components/RequestCard/RequestCard";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";

//--------------------------OTHERS---------------------------------//
import { handleStatusName } from "../../common";
import { StyledGridUl, StyledListItem } from "./styled";
import {
  getUnPlannedMaintenanceListMultiple,
  getPoolList,
  getActiveCounts,
  getTechList,
  getAreaList,
  getReasonGroup,
  getCostCenterList,
  clearFilterRes,
  resetCounts,
  resetStore,
  resetTechStore,
} from "../../store/actions/breakDownTasksActions";
import moment from "moment";

var userId = 0;

const constants = {
  dataSize: isMobile
    ? 5
    : window.matchMedia("(orientation: portrait)").matches
    ? 30
    : 15,
};

const ss = sessionStorage;
const plantId = localStorage.getItem("plantId");

//set current date
const setCurrentDate = (date) => {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var modifiedMonth = month <= 9 ? "0" + month : month;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var newStartDate = year + "-" + modifiedMonth + "-" + day;
  return newStartDate;
};

const GetFirstDayOfMonth = () => {
  var dt = new Date(); // current date of week
  return new Date(dt.getFullYear(), dt.getMonth(), 1);
};

const GetLastDayOfMonth = () => {
  var curr = new Date(); // get current date
  return new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
};

const GetFirstDayOfWeek = (date) => {
  var day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return moment(date.setDate(diff));
};

const GetLastDayOfWeek = (date) => {
  var day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return moment(date.setDate(diff + 6));
};

export default function BreakdownList(props) {
  //states
  const [state, setState] = useState({
    areaGroupCode: ss.getItem("bl_areaGroupCode") || null,
    breakdownEffect: parseInt(ss.getItem("bl_breakdownEffect")) || null,
    breakdownEffectName: ss.getItem("bl_breakdownEffectName") || null,
    breakdownReasonGroup:
      parseInt(ss.getItem("bl_breakdownReasonGroup")) || null,
    breakdownReasonGroupName: ss.getItem("bl_breakdownReasonGroupName") || null,
    callNote: ss.getItem("bl_callNote") || null,
    checkedMe: false,
    creatorId: parseInt(ss.getItem("bl_creatorId")) || null,
    creatorName: ss.getItem("bl_creatorName") || null,
    maintenanceNote: ss.getItem("bl_maintenanceNote") || null,
    poolIds: ls.get("bl_poolId_" + plantId) || [],
    status: ls.get("bl_status") || [1, 2],
    taskID: parseInt(ss.getItem("bl_taskID")) || "",
    technicianNote: null,
    user: parseInt(ss.getItem("bl_user"), 10) || null,
    userName: ss.getItem("bl_userName") || null,
    selectedAreaFilter: sessionStorage.getItem("bl_selectedAreaGroupIds")
      ? JSON.parse(sessionStorage.getItem("bl_selectedAreaGroupIds"))
      : [],
    selectedCostCenter: ss.getItem("bl_selectedCostCenter") || null,
    selectedCostCenterId:
      parseInt(ss.getItem("bl_selectedCostCenterId")) || null,
    selectedMaintenanceOrderId:
      ss.getItem("bl_selectedMaintenanceOrderId") || null,
    startDate:
      sessionStorage.getItem("bl_startDate") ||
      GetFirstDayOfMonth().toISOString(),
    endDate:
      sessionStorage.getItem("bl_endDate") ||
      GetFirstDayOfMonth().toISOString(),
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const [pageLoaded, setPageLoaded] = useState(false);
  const [userID, setUserID] = useState();
  const { t } = useTranslation("translation");

  const [assignedCount, setAssignedCount] = useState(0);
  const [cancelledCount, setCancelledCount] = useState(0);
  const [closedCount, setClosedCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [createdCount, setCreatedCount] = useState(0);
  const [pausedCount, setPausedCount] = useState(0);
  const [startedCount, setStartedCount] = useState(0);
  const [rowLength, setRowLength] = useState(3);
  const [rows, setRows] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    setRows([]);
  }, []);

  useEffect(() => {
    const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
    setUserID(
      oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "")
    );
    if (!location.state?.technicianMain) {
      LoadHandler();
    }
    if (isMobile) {
      setRowLength(1);
    }
  }, [plantId]);

  useEffect(() => {
    if (location.state?.technicianMain) {
      setRows(location.state?.technicianMain);
      setHasMore(false);
      setPageLoaded(true);
    }
  }, [location.state?.technicianMain]);

  const [refresh, setRefresh] = useState(false);
  const [poolData, setPoolData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [selectedStatusName, setSelectedStatusName] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [localUserId, setLocalUserId] = useState(0); //1781
  const [filterCount, setFilterCount] = useState(0);
  let [timeIntervals, setTimeIntervals] = useState([
    { id: 1, name: t("Today") },
    { id: 2, name: t("ThisWeek") },
    { id: 3, name: t("ThisMonth") },
    { id: 4, name: t("Manual") },
  ]);
  let [selectedTimeInterval, setSelectedTimeInterval] = useState(
    ls.get("bl_interval") || 3
  );

  const {
    unPlannedMaintenance,
    poolList,
    statusList,
    activeCounts,
    techList,
    areas,
    reasonGroup,
    effects,
    costCenters,
  } = useSelector(({ breakDownTask }) => breakDownTask);

  useEffect(() => {
    if (unPlannedMaintenance?.firstCallRes) {
      if (state.status.length === 0) {
        setRows([]);
      }
      setRows(
        Object.values(unPlannedMaintenance.firstCallRes.resultObject.content)
      );
      setHasMore(unPlannedMaintenance.firstCallRes.resultObject.hasNext);
      dispatch(getPoolList({ shouldFireStatus: true }));
    }

    if (unPlannedMaintenance?.fetchMoreDataRes) {
      const totalRows = [
        ...rows,
        ...unPlannedMaintenance.fetchMoreDataRes.resultObject.content,
      ];
      setRows(totalRows);

      const hasNextPage =
        unPlannedMaintenance.fetchMoreDataRes.resultObject.hasNext;
      setHasMore(hasNextPage);
      if (hasNextPage) {
        setCurrentPage(currentPage + 1);
      }
    }

    if (unPlannedMaintenance?.applyFilterRes) {
      setRows(
        Object.values(unPlannedMaintenance.applyFilterRes.resultObject.content)
      );
      if (unPlannedMaintenance.applyFilterRes.resultObject.hasNext) {
        setHasMore(unPlannedMaintenance.applyFilterRes.resultObject.hasNext);
        setCurrentPage(2);
      }
    }

    if (unPlannedMaintenance?.applyRefreshRes) {
      setRows([]);
      setRows(
        Object.values(unPlannedMaintenance.applyRefreshRes.resultObject.content)
      );

      window.scrollTo(0, 0); //go to top of the page after refresh

      if (unPlannedMaintenance.applyRefreshRes.resultObject.hasNext) {
        setHasMore(unPlannedMaintenance.applyRefreshRes.resultObject.hasNext);
        setCurrentPage(2);
      }
    }
  }, [unPlannedMaintenance]);

  useEffect(() => {
    if (poolList?.resultObject) {
      setPoolData(Object.values(poolList.resultObject));
    }
  }, [poolList]);

  useEffect(() => {
    if (statusList?.resultObject) {
      setPageLoaded(true);
      setStatusData(Object.values(statusList.resultObject));
      setSelectedStatusName(
        handleStatusName(Object.values(statusList.resultObject), state.status)
      );
      dispatch(resetStore());
    }
  }, [statusList]);

  useEffect(() => {
    if (activeCounts?.response && !isFilterDrawerOpen) {
      let entity = activeCounts.response.resultObject;

      setAssignedCount((prevState) => {
        if (prevState !== entity.assigned) {
          setRefresh(true);
        }
        return entity.assigned;
      });

      setCancelledCount((prevState) => {
        if (prevState !== entity.cancelled) {
          setRefresh(true);
        }
        return entity.cancelled;
      });

      setClosedCount((prevState) => {
        if (prevState !== entity.closed) {
          setRefresh(true);
        }
        return entity.closed;
      });

      setCompletedCount((prevState) => {
        if (prevState !== entity.completed) {
          setRefresh(true);
        }
        return entity.completed;
      });

      setCreatedCount((prevState) => {
        if (prevState !== entity.created) {
          setRefresh(true);
        }
        return entity.created;
      });

      setPausedCount((prevState) => {
        if (prevState !== entity.paused) {
          setRefresh(true);
        }
        return entity.paused;
      });

      setStartedCount((prevState) => {
        if (prevState !== entity.started) {
          setRefresh(true);
        }
        return entity.started;
      });
      dispatch(resetCounts());
    }
  }, [activeCounts]);

  useEffect(() => {
    if (refresh && !location.state?.technicianMain) {
      //Is there any changes on counts when load first time? if yes, update the screen, if no dont touch it.
      HandleRefresh();
      setFilterCount(
        ss.getItem("bl_filterCount") > 0 ? ss.getItem("bl_filterCount") : 0
      );
    }
    setRefresh(false);
  }, [refresh]);

  useEffect(() => {
    if (techList?.data) {
      let res = Object.values(techList.data);

      if (res.length > 0) {
        userId = res.filter((item) => item.userCode == userID)[0]?.id;
        setLocalUserId(userId); //when switch change, set local user id for fetching data and filter

        setRows([]);
        dispatch(resetTechStore());
      }
    }
    if (techList?.filterRes) {
      setUserData(Object.values(techList.filterRes.data));
      dispatch(getCostCenterList());
    }
  }, [techList]);

  useEffect(() => {
    if (areas?.resultObject) {
      setAreaData(areas.resultObject);
      areas.resultObject = areas.resultObject.filter(
        (item) => item.name == state.selectedAreaFilter
      );
    }
  }, [areas]);

  //filter responses

  useEffect(() => {
    if (reasonGroup?.resultObject) {
      setBreakdownReasonGroupData(Object.values(reasonGroup.resultObject));
    }
  }, [reasonGroup]);

  useEffect(() => {
    if (effects?.resultObject) {
      setBreakdownEffectData(Object.values(effects.resultObject));
      dispatch(getTechList({ filterRes: true }));
    }
  }, [effects]);

  useEffect(() => {
    if (costCenters?.resultObject) {
      LoadAreaData();
      setCostCenterData(Object.values(costCenters.resultObject));
    }
  }, [costCenters]);

  const InitialTotalStatusCounts = () => {
    dispatch(getActiveCounts());
  };

  const GetStatusCounts = () => {
    if (isFilterDrawerOpen) {
      return;
    }
    dispatch(getActiveCounts({ statusWithTimer: true }));
  };

  const getData = (isFilterCleared = false) => {
    const machineId = isFilterCleared
      ? 0
      : machineStates.selectedSubEquipmentCode ??
        machineStates.selectedMainEquipmentCode ??
        0;

    return {
      statusArr: ls.get("bl_status")
        ? ls.get("bl_status").toString()
        : [1, 2].toString(),
      poolIds: ls.get("bl_poolId_" + plantId) || [],
      assigneedIds: ss.getItem("bl_user")
        ? [parseInt(ss.getItem("bl_user"))]
        : [],
      creatorIds: ss.getItem("bl_creatorId")
        ? [parseInt(ss.getItem("bl_creatorId"))]
        : [],
      breakdownEffectIds: ss.getItem("bl_breakdownEffect")
        ? JSON.parse(ss.getItem("bl_breakdownEffect"))
        : [],
      breakdownGroupIds: ss.getItem("bl_breakdownReasonGroup")
        ? JSON.parse(ss.getItem("bl_breakdownReasonGroup"))
        : [],
      costCenterIds: ss.getItem("bl_selectedCostCenterId")
        ? JSON.parse(ss.getItem("bl_selectedCostCenterId"))
        : [],
      areaGroupIds: ss.getItem("bl_selectedAreaGroupIds")
        ? JSON.parse(ss.getItem("bl_selectedAreaGroupIds"))
        : [],
      taskId: ss.getItem("bl_taskID") ? parseInt(ss.getItem("bl_taskID")) : 0,
      orderId: ss.getItem("bl_selectedMaintenanceOrderId")
        ? parseInt(ss.getItem("bl_selectedMaintenanceOrderId"))
        : 0,
      taskNote: ss.getItem("bl_maintenanceNote")
        ? ss.getItem("bl_maintenanceNote")
        : null,
      orderNote: ss.getItem("bl_callNote") ? ss.getItem("bl_callNote") : null,
      machineId: location.state?.equipmentId || machineId,
      startDate: ss.getItem("bl_startDate")
        ? ss.getItem("bl_startDate")
        : GetFirstDayOfMonth().toISOString(),
      endDate: ss.getItem("bl_endDate")
        ? ss.getItem("bl_endDate")
        : GetLastDayOfMonth().toISOString(),
    };
  };

  const LoadHandler = () => {
    dispatch(getTechList());
    ss.removeItem("bl_user");

    const data = getData();

    let payload = {
      pageSize: constants.dataSize,
      currentPage: currentPage,
      data: data,
      firstCall: true,
    };

    dispatch(getUnPlannedMaintenanceListMultiple(payload));
    setCurrentPage(currentPage + 1);
  };

  const FetchMoreData = () => {
    if (!location.state?.technicianMain) {
      const data = getData();

      let payload = {
        data: data,
        currentPage: currentPage,
        pageSize: constants.dataSize,
        fetchMoreData: true,
      };

      dispatch(getUnPlannedMaintenanceListMultiple(payload));
    }
  };

  const SetDates = (start, end) => {
    setState((prevState) => ({
      ...prevState,
      startDate: start,
      endDate: end,
    }));
    sessionStorage.setItem("bl_startDate", start);
    sessionStorage.setItem("bl_endDate", end);
  };

  const HandleRefresh = () => {
    const data = getData();

    let payload = {
      pageSize: constants.dataSize,
      currentPage: 1,
      data: data,
      applyRefreshRes: true,
    };

    GetBadgeCount(data);
    dispatch(getUnPlannedMaintenanceListMultiple(payload));
  };

  const HandleApplyFilter = (isFilterCleared = false) => {
    setRows([]);
    const data = getData(isFilterCleared);

    let payload = {
      pageSize: constants.dataSize,
      currentPage: 1,
      data: data,
      applyFilterRes: true,
    };
    GetBadgeCount(data);
    dispatch(getUnPlannedMaintenanceListMultiple(payload));
  };

  const SetDefaultState = () => {
    setState({
      checkedMe: false,
      poolIds: ls.get("bl_poolId_" + plantId) || [],
      status: ls.get("bl_status") || [],
      callNote: null,
      user: null,
      userName: null,
      breakdownReasonGroup: [],
      breakdownEffect: [],
      creatorName: null,
      taskId: 0,
      maintenanceNote: null,
      areaGroupCode: null,
      selectedCostCenterId: [],
      selectedMaintenanceOrderId: null,
      selectedAreaFilter: null,
    });
  };

  const GetBadgeCount = (data) => {
    var fc = 0;
    if (refresh) {
      if (data.assigneedIds != 0 && !isNaN(data.assigneedIds)) fc++;
      if (data.creatorIds != 0 && !isNaN(data.creatorIds)) fc++;
      if (data.breakdownEffectIds != 0 && !isNaN(data.breakdownEffectId)) fc++;
      if (data.breakdownGroupIds != 0 && !isNaN(data.breakdownGroupId)) fc++;
      if (data.costCenterIds != 0) fc++;
      if (data.areaGroupIds != 0) fc++;
      if (data.taskId != 0) fc++;
      if (data.orderId != 0) fc++;
      if (data.taskNote != null) fc++;
      if (data.orderNote != null) fc++;
      if (data.machineId != 0) fc++;

      setFilterCount(fc);
      ss.setItem("bl_filterCount", fc);
    }
  };

  const HandleAssignToMe = (event) => {
    setState((pS) => ({
      ...pS,
      checkedMe: event.target.checked,
    }));
    if (event.target.checked) {
      ss.setItem("bl_user", localUserId);
    } else {
      ss.removeItem("bl_user");
    }

    setRows([]);
    HandleApplyFilter();
    setCurrentPage(1);
  };

  //set status
  const HandleStatus = (event) => {
    setState({ ...state, status: event.target.value });
    setSelectedStatusName(handleStatusName(statusData, event.target.value));
    ls.set("bl_status", event.target.value);
    setCurrentPage(1);
  };

  //set pool
  const HandlePool = (poolName) => {
    let ids = [];
    poolName.map((item) => ids.push(item.id));
    setState({ ...state, poolIds: ids });
    ls.set("bl_poolId_" + plantId, ids);
  };

  //set breakdown reason group
  const HandleBreakdownReasonGroup = (breakdownReasonGroup) => {
    let ids = [];
    breakdownReasonGroup.map((item) => ids.push(item.id));
    if (breakdownReasonGroup == null) {
      ss.removeItem("bl_breakdownReasonGroup");
    } else {
      ss.setItem("bl_breakdownReasonGroup", JSON.stringify(ids));
    }
    setState({ ...state, breakdownReasonGroup: ids });
  };

  //set breakdown reason effect
  const HandleBreakdownEffect = (breakdownEffect) => {
    let ids = [];
    breakdownEffect.map((item) => ids.push(item.id));
    if (breakdownEffect == null) {
      ss.removeItem("bl_breakdownEffect");
    } else {
      ss.setItem("bl_breakdownEffect", JSON.stringify(ids));
    }
    setState({ ...state, breakdownEffect: ids });
  };

  //set user ınfo
  const HandleUser = (userName) => {
    const userInfo = userData.filter((item) => item.userName == userName);
    let userId = null;

    if (userInfo[0] != undefined) {
      // Filter if user exist
      userId = userInfo[0].id;
    }
    if (userName == null) {
      ss.removeItem("bl_userName");
      ss.removeItem("bl_user");
    } else {
      ss.setItem("bl_userName", userName);
      ss.setItem("bl_user", userId);
    }

    setState({ ...state, checkedMe: false, user: userId, userName: userName });
  };

  // Set start date
  const HandleStartDate = (date) => {
    if (date == null) {
      sessionStorage.removeItem("bl_startDate");
    } else {
      sessionStorage.setItem("bl_startDate", moment(date).format("YYYY-MM-DD"));
    }

    ls.set("bl_interval", 4);
    setSelectedTimeInterval(4);
    setState({ ...state, startDate: date });
  };

  // Set end date
  const HandleEndDate = (date) => {
    if (date == null) {
      sessionStorage.removeItem("bl_endDate");
    } else {
      sessionStorage.setItem("bl_endDate", moment(date).format("YYYY-MM-DD"));
    }

    ls.set("bl_interval", 4);
    setState({ ...state, endDate: date });
  };

  // set creator for filter
  const HandleCreatorName = (creatorName) => {
    const userInfo = userData.filter((item) => item.userName == creatorName);
    let creatorCode = null;

    if (userInfo[0] != undefined) {
      creatorCode = userInfo[0].id;
    }
    if (creatorName == null) {
      ss.removeItem("bl_creatorName");
      ss.removeItem("bl_creatorId");
    } else {
      ss.setItem("bl_creatorName", creatorName);
      ss.setItem("bl_creatorId", creatorCode);
    }

    setState({
      ...state,
      checkedMe: false,
      creatorName: creatorName,
      creatorCode: creatorCode,
    });
  };

  const HandleCostCenterChange = (costCenter) => {
    let ids = [];
    costCenter.map((item) => ids.push(item.id));
    if (costCenter == null) {
      ss.removeItem("bl_selectedCostCenterId");
    } else {
      ss.setItem("bl_selectedCostCenterId", JSON.stringify(ids));
    }
    setState({ ...state, selectedCostCenterId: ids });
  };

  const HandleAreaFilterChange = (areaName) => {
    let areaGroupIds = [];
    areaName?.map((item) => areaGroupIds.push(item.id));
    if (areaName == null) {
      sessionStorage.removeItem("bl_selectedAreaGroupIds");
    } else {
      sessionStorage.setItem(
        "bl_selectedAreaGroupIds",
        JSON.stringify(areaGroupIds)
      );
    }
    setState({ ...state, selectedAreaFilter: areaGroupIds });
  };

  const HandleTimeSelection = (id) => {
    switch (id) {
      case 1: //gün
        SetDates(setCurrentDate(new Date()), setCurrentDate(new Date()));
        break;
      case 2: //hafta
        SetDates(
          GetFirstDayOfWeek(new Date()).toISOString(),
          GetLastDayOfWeek(new Date()).toISOString()
        );
        break;
      case 3: //ay
        SetDates(
          GetFirstDayOfMonth().toISOString(),
          GetLastDayOfMonth().toISOString()
        );
        break;
      default:
        SetDates(setCurrentDate(new Date()), setCurrentDate(new Date()));
        break;
    }
  };

  const HandleTimeInterval = (e) => {
    setSelectedTimeInterval(e.target.value);
    ls.set("bl_interval", e.target.value);
    HandleTimeSelection(e.target.value);
  };

  //detail popup
  const [breakdownReasonGroupData, setBreakdownReasonGroupData] = useState([]);
  const [breakdownEffectData, setBreakdownEffectData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [costCenterData, setCostCenterData] = useState([]);

  //set taskID state with taskNo area which comes from filter
  const FilterWithID = (e) => {
    if (e.target.value == null) {
      ss.removeItem("bl_taskID");
    } else {
      ss.setItem("bl_taskID", e.target.value);
    }

    setState({ ...state, taskID: e.target.value });
  };

  const FilterWithMaintenanceNote = (e) => {
    if (e.target.value == null) {
      ss.removeItem("bl_maintenanceNote");
    } else {
      ss.setItem("bl_maintenanceNote", e.target.value);
    }

    setState({ ...state, maintenanceNote: e.target.value });
  };

  const FilterWithCallNote = (e) => {
    if (e.target.value == null) {
      ss.removeItem("bl_callNote");
    } else {
      ss.setItem("bl_callNote", e.target.value);
    }

    setState({ ...state, callNote: e.target.value });
  };

  const FilterOrderId = (e) => {
    if (e.target.value == null) {
      ss.removeItem("bl_selectedMaintenanceOrderId");
    } else {
      ss.setItem("bl_selectedMaintenanceOrderId", e.target.value);
    }

    setState({ ...state, selectedMaintenanceOrderId: e.target.value });
  };

  //load area data for popup
  let [areaData, setAreaData] = useState([]);
  const LoadAreaData = () => {
    dispatch(getAreaList());
  };

  const initialMachineStates = (isCleared = false) => {
    return {
      ssAbr: "bl",
      selectedAreaCode: isCleared
        ? null
        : ss.getItem("bl_selectedAreaCode") ?? null,
      selectedAreaName: isCleared
        ? null
        : ss.getItem("bl_selectedAreaName") ?? null,
      selectedMainEquipmentCode: isCleared
        ? null
        : ss.getItem("bl_selectedMainEquipmentCode") ?? null,
      selectedMainEquipmentName: isCleared
        ? null
        : ss.getItem("bl_selectedMainEquipmentName") ?? null,
      selectedSubEquipmentCode: isCleared
        ? null
        : ss.getItem("bl_selectedSubEquipmentCode") ?? null,
      selectedSubEquipmentName: isCleared
        ? null
        : ss.getItem("bl_selectedSubEquipmentName") ?? null,
    };
  };
  const [machineStates, setMachineStates] = useState(initialMachineStates);
  const HandleClearMachineStates = () => {
    ss.removeItem("bl_selectedAreaCode");
    ss.removeItem("bl_selectedAreaName");
    ss.removeItem("bl_selectedMainEquipmentCode");
    ss.removeItem("bl_selectedMainEquipmentName");
    ss.removeItem("bl_selectedSubEquipmentCode");
    ss.removeItem("bl_selectedSubEquipmentName");
    setMachineStates(initialMachineStates(true));
  };

  const HandleClearFilter = () => {
    ls.set("bl_poolId_" + plantId, []);
    ls.set("bl_status", []);

    HandleClearMachineStates();

    handleClearss();
    SetDefaultState();
    HandleApplyFilter(true);
    setFilterCount(0);
  };

  const handleClearss = () => {
    ss.removeItem("bl_areaGroupCode");
    ss.removeItem("bl_breakdownEffect");
    ss.removeItem("bl_breakdownReasonGroup");
    ss.removeItem("bl_callNote");
    ss.removeItem("bl_creatorName");
    ss.removeItem("bl_creatorId");
    ss.removeItem("bl_maintenanceNote");
    ss.removeItem("bl_taskID");
    ss.removeItem("bl_user");
    ss.removeItem("bl_userName");
    ss.removeItem("bl_selectedAreaFilter");
    ss.removeItem("bl_selectedAreaGroupIds");
    ss.removeItem("bl_selectedCostCenterId");
    ss.removeItem("bl_selectedMaintenanceOrderId");
    ss.removeItem("bl_StartDate");
    ss.removeItem("bl_EndDate");
  };

  const goBackToEquipmentNotes = () => {
    props.history.goBack();
  };

  const equipmentNotesBackArrow = () => {
    if (location.state?.equipmentId) {
      return (
        <Grid id="bd_grid_1" item xs={1} style={{ marginTop: 20 }}>
          <IconButton id="bd_iconBtn" onClick={goBackToEquipmentNotes}>
            <ArrowBackIos id="bd_arrowBack" fontSize="inherit" align="center" />
          </IconButton>
        </Grid>
      );
    } else {
      return null;
    }
  };

  const HandleRowLength = (event) => {
    if (event.target.value != "") {
      setRowLength(event.target.value);
      if (event.target.value > 5) {
        FetchMoreData();
      }
    }
  };

  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  useEffect(() => {
    if (!location.state?.technicianMain) {
      InitialTotalStatusCounts();
      const interval = setInterval(() => {
        GetStatusCounts();
      }, 10000);

      return () => clearInterval(interval);
    }
  }, [plantId, isFilterDrawerOpen]);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    if (open) {
      dispatch(getReasonGroup());
    } else {
      dispatch(clearFilterRes());
    }

    setIsFilterDrawerOpen(open);
  };

  const filter = () => {
    return (
      <DetailFilter
        HandleAssignToMe={HandleAssignToMe}
        HandleRowLength={HandleRowLength}
        checkedMe={state.checkedMe}
        HandleStatus={HandleStatus}
        statusData={statusData}
        status={state.status}
        selectedStatusName={selectedStatusName}
        HandlePool={HandlePool}
        poolData={poolData}
        poolIds={state.poolIds}
        HandleUser={HandleUser}
        userData={userData}
        userName={state.userName}
        HandleCreatorName={HandleCreatorName}
        creatorName={state.creatorName}
        HandleBreakdownEffect={HandleBreakdownEffect}
        breakdownEffectData={breakdownEffectData}
        breakdownEffect={state.breakdownEffect}
        HandleBreakdownReasonGroup={HandleBreakdownReasonGroup}
        breakdownReasonGroupData={breakdownReasonGroupData}
        breakdownReasonGroup={state.breakdownReasonGroup}
        HandleCostCenterChange={HandleCostCenterChange}
        costCenterData={costCenterData}
        selectedCostCenterId={state.selectedCostCenterId}
        HandleAreaFilterChange={HandleAreaFilterChange}
        areaData={areaData}
        selectedAreaFilter={state.selectedAreaFilter}
        FilterWithID={FilterWithID}
        taskId={state.taskID}
        FilterOrderId={FilterOrderId}
        selectedMaintenanceOrderId={state.selectedMaintenanceOrderId}
        FilterWithMaintenanceNote={FilterWithMaintenanceNote}
        maintenanceNote={state.maintenanceNote}
        FilterWithCallNote={FilterWithCallNote}
        callNote={state.callNote}
        setMachineStates={setMachineStates}
        machineStates={machineStates}
        isAreaNotFiltered={true}
        isMultipleAreaGroup={true}
        HandleStartDate={HandleStartDate}
        HandleEndDate={HandleEndDate}
        startDate={state.startDate}
        endDate={state.endDate}
        maxDate={new Date()}
        HandleTimeInterval={HandleTimeInterval}
        selectedTimeInterval={selectedTimeInterval}
        timeIntervals={timeIntervals}
      />
    );
  };

  return (
    <div>
      {pageLoaded === true ? (
        <div>
          <Grid
            id="bl_Grid0"
            style={{ marginTop: 20, marginLeft: 20, marginRight: 20 }}
          >
            {!location.state?.technicianMain ? (
              <Grid id="bl_Grid_1" container spacing={1}>
                <FilterDrawer
                  open={isFilterDrawerOpen}
                  onOpen={toggleDrawer(true)}
                  onClose={toggleDrawer(false)}
                  HandleClearFilter={HandleClearFilter}
                  HandleApplyFilter={() => {
                    setIsFilterDrawerOpen(false);
                    HandleApplyFilter();
                  }}
                  detailFilter={filter()}
                />
                <FilterButton onClick={() => toggleDrawer(true)} />
              </Grid>
            ) : null}
            <Grid id="bl_Grid_5">
              <InfiniteScroll
                id="bl_InfiniteScroll"
                dataLength={rows.length} //This is important field to render the next data
                next={FetchMoreData}
                hasMore={hasMore}
                loader={
                  rows.length > 15 ? (
                    <LinearProgress id="bl_LinearProgress" />
                  ) : null
                }
                endMessage={
                  rows.length == 0 ? (
                    <p style={{ textAlign: "center" }}>
                      <b>{t("ThereIsNoRecord")}</b>
                    </p>
                  ) : (
                    <p style={{ textAlign: "center" }}>
                      <b>{t("YouHaveSeenItAll")}</b>
                    </p>
                  )
                }
              >
                <StyledGridUl rows rowLength={rowLength} id="bl_StyledGridUl">
                  {rows.map((row, index) => {
                    return (
                      <StyledListItem id="bl_StyledListItem">
                        <li
                          id={`bl_li_${index}`}
                          key={index}
                          style={{ margin: "5px" }}
                        >
                          <RequestCard
                            id="bl_RequestCard"
                            rows={[row]}
                            detail={false}
                            isPlannedMaintenance={false}
                            page="breakdownList"
                          />
                        </li>
                      </StyledListItem>
                    );
                  })}
                </StyledGridUl>
              </InfiniteScroll>
            </Grid>
          </Grid>
        </div>
      ) : null}

      <LoadingBackdrop id="bl_loginBackDrop" />
    </div>
  );
}
